import React, { useEffect, useState } from "react";
import { Checkbox, InputNumber, Spin, message } from "antd";
import { FiSave, FiShoppingCart } from "react-icons/fi";
import { MdOutlineMedicalServices } from "react-icons/md";
import { getImg } from "../../../Api/getImg";
import { formatDateTime } from "../../../utils/helpers";
import drEasyApi from "../../../Api/Customapi";

export default function FinancialNotesTab({
  patientData,
  orderNotes,
  setOrderNotes,
  session,
  submittingOrder,
  setSubmittingOrder,
  existingOrderReport,
  loadingOrderReport,
  fetchOrderReport,
}) {
  const [doctorServices, setDoctorServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState({});
  const [servicesLoading, setServicesLoading] = useState(false);

  console.log(session, "Sdsd");
  console.log(patientData, "sds");

  const fetchServices = async () => {
    setServicesLoading(true);
    try {
      if (patientData.centerID) {
        const res = await drEasyApi.get(`/api/Services/GetCenterServices?CenterId=${patientData.centerID}`, { params: { ClinicId: session.clinicId, ShowGenral: true } });
        setDoctorServices(res.data);
      } else if (session) {
        const res = await drEasyApi.get(`/api/Services/GetCenterServices?CenterId=${session.centerId}`, { params: { ClinicId: session.clinicId, ShowGenral: true } });

        setDoctorServices(res.data);
      }
    } catch (err) {
      console.error("Error fetching services:", err);
    } finally {
      setServicesLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  const handleServiceToggle = (serviceId, service) => {
    setSelectedServices((prev) => {
      const next = { ...prev };
      if (next[serviceId]) {
        delete next[serviceId];
      } else {
        next[serviceId] = {
          serviceId,
          quantity: 1,
          note: "",
          unitPrice: service.priceAfterDiscount ?? service.price ?? 0,
          title: service.title,
        };
      }
      return next;
    });
  };

  const updateServiceQuantity = (serviceId, quantity) =>
    setSelectedServices((prev) => ({
      ...prev,
      [serviceId]: { ...prev[serviceId], quantity: quantity || 1 },
    }));

  const updateServiceNote = (serviceId, note) =>
    setSelectedServices((prev) => ({
      ...prev,
      [serviceId]: { ...prev[serviceId], note },
    }));

  const handleAddOrderReport = async () => {
    const servicesArray = Object.values(selectedServices).map((s) => ({
      serviceId: s.serviceId,
      quantity: s.quantity,
      note: s.note || "",
    }));
    setSubmittingOrder(true);
    try {
      await drEasyApi.post("api/Reports/OrderReport", {
        data: {
          patientSessionId: session.sessionId,
          bookingId: patientData.bookingId,
          notes: orderNotes,
          services: servicesArray,
        },
      });
      message.success("Order report submitted successfully");
      setSelectedServices({});
      await fetchOrderReport();
    } catch {
      message.error("Failed to submit order report");
    } finally {
      setSubmittingOrder(false);
    }
  };

  if (loadingOrderReport) {
    return (
      <div className="flex justify-center items-center py-8">
        <Spin size="large" />
      </div>
    );
  }

  if (existingOrderReport) {
    return (
      <div className="bg-primary/10 rounded-xl p-4 sm:p-6 border border-primary-300 shadow-lg">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-4">
          <h3 className="text-lg sm:text-xl font-bold text-gray-800">
            Existing Order Report
          </h3>
          <span className="self-start sm:self-auto bg-green-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
            Submitted
          </span>
        </div>

        <div className="bg-white rounded-lg p-3 sm:p-4 mb-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-4">
            <div>
              <p className="text-sm text-gray-600">Created At</p>
              <p className="font-semibold text-gray-900 text-sm sm:text-base">
                {formatDateTime(`${existingOrderReport.createdAt}Z`)}
              </p>
            </div>
          </div>

          {existingOrderReport.notes && (
            <div className="mb-4">
              <p className="text-sm text-gray-600 mb-1">Order Notes</p>
              <p className="text-gray-900 text-sm sm:text-base bg-gray-50 p-3 rounded-lg">
                {existingOrderReport.notes}
              </p>
            </div>
          )}

          <div>
            <p className="text-sm text-gray-600 mb-3 font-semibold">
              Services Ordered
            </p>
            <div className="space-y-2">
              {existingOrderReport.services.map((service, index) => (
                <div
                  key={index}
                  className="bg-gray-50 p-3 sm:p-4 rounded-lg border border-gray-200"
                >
                  <h4 className="font-semibold text-gray-900 text-sm sm:text-base">
                    {service.serviceTitle}
                  </h4>
                  <p className="text-sm text-gray-600">
                    Quantity: {service.quantity}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4 sm:space-y-6">
      {/* Order notes */}
      <div className="bg-gradient-to-br from-primary/5 to-primary/10 rounded-xl p-3 sm:p-4 sm:py-2 border-2 border-primary/20">
        <label className="block text-base sm:text-lg font-semibold text-gray-800 mb-2 sm:mb-3">
          Order Notes
        </label>
        <textarea
          className="w-full min-h-[100px] sm:min-h-[120px] p-3 sm:p-4 border-2 border-primary/30 rounded-lg focus:outline-none focus:border-primary/90 focus:ring-2 focus:ring-primary transition-all resize-y bg-white text-sm sm:text-base"
          onChange={(e) => setOrderNotes(e.target.value)}
          value={orderNotes}
          placeholder="Add any special instructions or notes for this order..."
        />
      </div>

      {/* Services */}
      <div>
        <div className="flex items-center justify-between my-3 sm:my-4">
          <h2 className="text-lg sm:text-xl font-bold text-gray-800 flex items-center gap-2">
            <FiShoppingCart className="text-primary" size={20} />
            Select Services
          </h2>
          {Object.keys(selectedServices).length > 0 && (
            <span className="bg-primary text-white px-3 py-1 rounded-full text-xs sm:text-sm font-semibold">
              {Object.keys(selectedServices).length} Selected
            </span>
          )}
        </div>

        {servicesLoading ? (
          <div className="flex justify-center items-center py-12">
            <Spin size="large" />
          </div>
        ) : (
          <div className="max-h-[400px] sm:max-h-[500px] overflow-y-auto border-2 border-gray-200 rounded-xl p-3 sm:p-4 bg-gray-50">
            {doctorServices?.length > 0 ? (
              <div className="space-y-4 sm:space-y-6">
                {doctorServices.map((clinic) => (
                  <div key={clinic.clinicId ?? clinic.clinicName}>
                    <h3 className="text-xs sm:text-sm font-bold text-primary uppercase tracking-wider mb-2 px-1">
                      {clinic.clinicName}
                    </h3>
                    <div className="space-y-2 sm:space-y-3">
                      {clinic.services.map((service) => (
                        <div
                          key={service.id}
                          className={`bg-white rounded-xl p-3 sm:p-4 shadow-sm hover:shadow-lg transition-all duration-300 border-2 ${selectedServices[service.id]
                              ? "border-primary bg-primary/5"
                              : "border-gray-200 hover:border-primary/50"
                            }`}
                        >
                          <div className="flex items-start gap-2 sm:gap-4">
                            <Checkbox
                              checked={!!selectedServices[service.id]}
                              onChange={() =>
                                handleServiceToggle(service.id, service)
                              }
                              className="mt-1 flex-shrink-0"
                            />
                            {service.photoID ? (
                              <img
                                src={getImg(service.photoID)}
                                className="w-12 h-12 sm:w-16 sm:h-16 rounded-lg object-cover shadow-md flex-shrink-0"
                                alt={service.title}
                              />
                            ) : (
                              <MdOutlineMedicalServices className="text-primary w-8 h-8 sm:w-12 sm:h-12 flex-shrink-0" />
                            )}
                            <div className="flex-1 min-w-0">
                              <h3 className="font-semibold text-gray-900 text-sm sm:text-lg leading-tight">
                                {service.title}
                              </h3>


                              {selectedServices[service.id] && (
                                <div className="mt-3 space-y-3 bg-gray-50 p-3 sm:p-4 rounded-lg border border-gray-200">
                                  {/* Stack on mobile, side-by-side on md+ */}
                                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                    <div>
                                      <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-1.5">
                                        Quantity
                                      </label>
                                      <InputNumber
                                        min={1}
                                        max={100}
                                        value={
                                          selectedServices[service.id].quantity
                                        }
                                        onChange={(value) =>
                                          updateServiceQuantity(
                                            service.id,
                                            value
                                          )
                                        }
                                        className="w-full"
                                        size="middle"
                                      />
                                    </div>
                                    <div>
                                      <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-1.5">
                                        Service Note{" "}
                                        <span className="font-normal text-gray-400">
                                          (Optional)
                                        </span>
                                      </label>
                                      <textarea
                                        value={
                                          selectedServices[service.id].note ||
                                          ""
                                        }
                                        onChange={(e) =>
                                          updateServiceNote(
                                            service.id,
                                            e.target.value
                                          )
                                        }
                                        placeholder="Add specific notes..."
                                        className="w-full px-3 py-1.5 text-sm border-2 border-gray-300 rounded-lg focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/50 transition-all resize-none"
                                        rows={1}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center text-gray-500 py-4">
                <p className="text-base sm:text-lg font-semibold">
                  No services available
                </p>
                <p className="text-sm text-gray-400 mt-2">
                  Please check back later
                </p>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Submit button — full width on mobile */}
      <button
        onClick={handleAddOrderReport}
        disabled={submittingOrder}
        className="w-full sm:w-auto mt-3 flex items-center justify-center gap-2 bg-primary text-white px-6 py-2.5 rounded-lg hover:bg-primary/90 transition-all font-semibold text-base sm:text-lg shadow hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <FiSave size={16} />
        {submittingOrder ? "Submitting ..." : "Submit"}
      </button>
    </div>
  );
}